import React, { useState } from 'react';
import ProgressWheelCard from './ProgressWheelCard';
import { Grid, Button, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Tooltip, Fab, Typography, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Chat as ChatIcon, FitnessCenter as FitnessCenterIcon, Opacity as WaterIcon, Bedtime as SleepIcon, DirectionsRun as StepsIcon, Favorite as HeartIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const StyledFab = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(3),
  right: theme.spacing(3),
  backgroundColor: '#6200EA',
  color: '#FFFFFF',
  '&:hover': {
    backgroundColor: '#3700B3',
  },
  transition: 'background-color 0.3s ease-in-out',
}));

const StyledDialog = styled(Dialog)(({ theme }) => ({
  transition: 'transform 0.3s ease-in-out',
  transformOrigin: 'center',
}));

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: '#6200EA',
  color: '#FFFFFF',
  textAlign: 'center',
  padding: theme.spacing(2),
  fontWeight: 'bold',
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: '#f9f9f9',
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(2),
  justifyContent: 'center',
}));

const Dashboard = () => {
  const [open, setOpen] = useState(false);
  const [question, setQuestion] = useState('');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSend = () => {
    console.log("Question sent to trainer: ", question);
    setQuestion('');  // Clear the input after sending
    setOpen(false);
  };

  return (
    <div className="dashboard" style={{ padding: '20px' }}>
      <Tooltip title="Ask Trainer">
        <StyledFab onClick={handleClickOpen}>
          <ChatIcon />
        </StyledFab>
      </Tooltip>

      <StyledDialog 
        open={open} 
        onClose={handleClose} 
        maxWidth="sm" 
        fullWidth
      >
        <StyledDialogTitle>
          Ask Your Trainer
        </StyledDialogTitle>
        <StyledDialogContent>
          <Typography variant="h6" gutterBottom>
            Your Personal Health Advisor
          </Typography>
          <StyledTextField
            autoFocus
            margin="dense"
            label="Your Question"
            type="text"
            fullWidth
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            variant="outlined"
            helperText="Please provide as much detail as possible."
          />

          <Typography variant="subtitle1" color="textSecondary" style={{ marginTop: '16px' }}>
            Here are some tips from your trainer:
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <FitnessCenterIcon style={{ color: '#FF5722' }}/>
              </ListItemIcon>
              <ListItemText primary="Consistency is key to achieving your fitness goals. Aim for regular workouts." />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <WaterIcon style={{ color: '#189ab4' }} />
              </ListItemIcon>
              <ListItemText primary="Stay hydrated! Aim for at least 8 glasses of water a day." />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <SleepIcon style={{ color: '#75e6da' }} />
              </ListItemIcon>
              <ListItemText primary="Ensure you get 7-8 hours of sleep to aid recovery and performance." />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <StepsIcon style={{ color: '#FFC107' }}/>
              </ListItemIcon>
              <ListItemText primary="Try to achieve 10,000 steps daily to keep your activity level up." />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <HeartIcon style={{ color: '#05445e' }}/>
              </ListItemIcon>
              <ListItemText primary="Monitor your heart rate during exercise to stay within your target zone." />
            </ListItem>
          </List>
        </StyledDialogContent>
        <StyledDialogActions>
          <Button onClick={handleClose} color="secondary" variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleSend} color="primary" variant="contained">
            Send
          </Button>
        </StyledDialogActions>
      </StyledDialog>

      <Grid container spacing={3}>
        {/* ProgressWheelCard components here */}
        <Grid item xs={12} sm={6} md={4}>
          <ProgressWheelCard title="Calories " value={2000} target={2500} unit="kcal" color={['#FFCC80', '#FFA726']} icon="calories" />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ProgressWheelCard title="Sleep" value={8} target={8} unit="hrs" color={['#A5D6A7', '#66BB6A']} icon="sleep" />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ProgressWheelCard title="Steps" value={50} target={10000} unit="steps" color={['#81D4FA', '#29B6F6']} icon="steps" />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ProgressWheelCard title="Water" value={2000} target={3000} unit="ml" color={['#F48FB1', '#F06292']} icon="water" />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ProgressWheelCard title="Weight" value={75} target={70} unit="kg" color={['#FFAB91', '#FF7043']} icon="weight" />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ProgressWheelCard title="Workout" value={2} target={6} unit="days" color={['#FFF176', '#FFEB3B']} icon="workout" />
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;
